import { FileDownload as ExportIcon } from '@mui/icons-material'
import { Box, IconButton, Tooltip } from '@mui/material'
import React from 'react'

import { AddRowButton } from './AddRowButton'

type Props = {
	onExport?: () => void
	onAdd?: () => void
}

export const Toolbar: React.FC<Props> = ({ onExport, onAdd }) => (
	<Box
		className="MuiDataGrid-toolbarContainer"
		sx={{
			display: 'flex',
			justifyContent: 'flex-end',
			p: 1,
			borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
		}}
	>
		{onAdd !== undefined && <AddRowButton onClick={onAdd} />}
		{onExport ? (
			<Tooltip title="Export to CSV">
				<IconButton onClick={onExport} size="small">
					<ExportIcon />
				</IconButton>
			</Tooltip>
		) : null}
	</Box>
)
